import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { useRouteLoaderData } from '@remix-run/react';
import AnnounceKit from 'announcekit-react';
import * as React from 'react';
import { ClientOnly } from 'remix-utils';
import type { LoaderData } from '~/root';

const ref = React.createRef<typeof AnnounceKit>();

export default function AnnounceKitComponent() {
  const { announceKitWidgetId } = useRouteLoaderData('root') as LoaderData;

  return (
    <>
      <IconButton color="inherit" aria-label="cart" aria-haspopup="true" onClick={() => ref.current?.open()}>
        <Badge badgeContent={10} variant="dot" sx={{ '& .MuiBadge-badge': { bgcolor: 'secondary.main' } }}>
          <NotificationsOutlinedIcon sx={{ color: 'primary.dark' }} fontSize="medium" />
        </Badge>
      </IconButton>
      <ClientOnly>
        {() => <AnnounceKit ref={ref} widget={`https://announcekit.co/widgets/v2/${announceKitWidgetId}`} />}
      </ClientOnly>
    </>
  );
}
